/*
Copyright (c) 2016 Daybrush
name: vue-scenejs
license: MIT
author: Daybrush
repository: https://github.com/daybrush/scenejs/tree/master/packages/vue-scenejs
version: 1.1.0
*/
import { Component } from 'vue-property-decorator';
import Scene, { OPTIONS, EVENTS, SceneItem } from 'scenejs';
import Vue from 'vue';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */
var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };

  return extendStatics(d, b);
};

function __extends(d, b) {
  extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

var SceneInterface =
/*#__PURE__*/
function (_super) {
  __extends(SceneInterface, _super);

  function SceneInterface() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.isReady = false;
    return _this;
  }

  var __proto = SceneInterface.prototype;

  __proto.setTime = function (time) {
    this.item.setTime(time);
  };

  __proto.getTime = function () {
    return this.item.getTime();
  };

  __proto.play = function () {
    this.css !== false ? this.item.playCSS() : this.item.play();
  };

  __proto.pause = function () {
    this.item.pause();
  };

  __proto.isPaused = function () {
    return this.item.isPaused();
  };

  __proto.getItem = function () {
    return this.item;
  };

  __proto.getDuration = function () {
    return this.item.getDuration();
  };

  __proto.init = function () {
    var _this = this;

    if (!this.ready || this.isReady) {
      return;
    }

    this.isReady = true;
    var item = this.item;
    var sceneOptions = {};

    if (this.keyframes) {
      this.item.load(this.keyframes);
    }

    OPTIONS.forEach(function (name) {
      sceneOptions[name] = _this.$props[name];
    });
    item.setOptions(sceneOptions);
    EVENTS.forEach(function (name) {
      item.on(name, function (e) {
        _this.$emit(name, e);
      });
    });

    if (this.autoplay !== false) {
      this.play();
    } else if (this.time !== -1) {
      this.setTime(this.time);
    } else {
      this.setTime(0);
    }
  };

  __proto.render = function () {
    return this.$slots["default"][0];
  };

  __proto.updated = function () {
    if (this.ready && !this.isReady) {
      this.init();
    }

    if (this.time !== -1 && (this.autoplay === false || this.item.getPlayState() === 'paused')) {
      this.item.setTime(this.time);
    }
  };

  __proto.beforeDestroy = function () {
    this.item.off();
  };

  SceneInterface = __decorate([Component({
    props: {
      keyframes: {
        type: Object,
        "default": {}
      },
      css: {
        type: Boolean,
        "default": false
      },
      autoplay: {
        type: Boolean,
        "default": false
      },
      time: {
        type: [String, Number],
        "default": -1
      },
      easing: {
        type: [String, Function, Number],
        "default": 0
      },
      fillMode: {
        type: String,
        "default": 'forwards'
      },
      direction: {
        type: String,
        "default": 'normal'
      },
      iterationCount: {
        type: [Number, String],
        "default": 1
      },
      delay: {
        type: Number,
        "default": 0
      },
      playSpeed: {
        type: Number,
        "default": 1
      },
      ready: {
        type: Boolean,
        "default": true
      }
    }
  })], SceneInterface);
  return SceneInterface;
}(Vue);

var VueScene =
/*#__PURE__*/
function (_super) {
  __extends(VueScene, _super);

  function VueScene() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.item = new Scene({}, {
      selector: true
    });
    return _this;
  }

  var __proto = VueScene.prototype;

  __proto.mounted = function () {
    this.init();
  };

  VueScene = __decorate([Component], VueScene);
  return VueScene;
}(SceneInterface);

var VueSceneItem =
/*#__PURE__*/
function (_super) {
  __extends(VueSceneItem, _super);

  function VueSceneItem() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.item = new SceneItem();
    return _this;
  }

  var __proto = VueSceneItem.prototype;

  __proto.mounted = function () {
    this.item.setElement(this.$el);
    this.init();
  };

  VueSceneItem = __decorate([Component], VueSceneItem);
  return VueSceneItem;
}(SceneInterface);

export { VueScene, VueSceneItem };
//# sourceMappingURL=scene.esm.js.map
